var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  transition: all 0.25s ease-in-out;\n  opacity: 1;\n  font-size: 13px;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  min-height: 24px;\n  height: auto;\n  &.no-errors {\n    opacity: 1;\n    display: block;\n    overflow: hidden;\n    height: 0px;\n    min-height: 0px;\n  }\n'], ['\n  color: ', ';\n  transition: all 0.25s ease-in-out;\n  opacity: 1;\n  font-size: 13px;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  min-height: 24px;\n  height: auto;\n  &.no-errors {\n    opacity: 1;\n    display: block;\n    overflow: hidden;\n    height: 0px;\n    min-height: 0px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 0px;\n  background-color: ', ';\n  list-style: none;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  li {\n    margin-left: 0px;\n    font-size: 13px;\n    color: ', ';\n    display: inline;\n    margin-right: 6px;\n  }\n'], ['\n  margin-top: 0px;\n  background-color: ', ';\n  list-style: none;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  li {\n    margin-left: 0px;\n    font-size: 13px;\n    color: ', ';\n    display: inline;\n    margin-right: 6px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import { isNil, isEmpty } from 'ramda';
var ErrorParagraph = styled.p(_templateObject, function (props) {
  return props.theme.colours.danger.dark;
});
var ErrorList = styled.ul(_templateObject2, function (props) {
  return props.theme.colours.neutral.lightest;
}, function (props) {
  return props.theme.colours.danger.dark;
});

var Errors = function Errors(props) {
  var errors = props.errors;
  var showErrors = !isNil(errors) && !isEmpty(errors);
  var space = '\xA0';

  if (showErrors) {
    if (errors.length === 1) {
      return React.createElement(ErrorParagraph, null, errors[0]);
    } else {
      return React.createElement(ErrorList, null, errors.map(function (error, index) {
        return React.createElement('li', {
          key: index
        }, error.replace('.', ''), '.');
      }));
    }
  } else {
    return React.createElement(ErrorParagraph, {
      className: 'no-errors'
    }, space);
  }
};

export default Errors;